import classNames from 'classnames';

type Props = {
  sizeVariant?: string;
  day: string;
  month: string;
};

export const BadgeDate = ({ sizeVariant, day, month }: Props) => {
  const classes = classNames('bo-badge-date', {
    [`bo-badge-date--${sizeVariant}`]: !!sizeVariant,
  });

  return (
    <div className={classes}>
      <span className="bo-badge-date__day">{day}</span>
      <span className="bo-badge-date__month">{month}</span>
    </div>
  );
};
